import React from "react";
import profile from "../../../assets/img/temp/profile.png";
import img from "../../../assets/img/blog/Rectangle 99.png";
import clock from "../../../assets/img/icons/clockcopy.svg";
import eye from "../../../assets/img/icons/eye.svg";
import heart from "../../../assets/img/icons/heartred.svg";
import message from "../../../assets/img/icons/message-text.svg";
import moment from 'jalali-moment'
import parse from 'html-react-parser';
import { useNavigate } from "react-router-dom";

const BlogCard = ({info}) => {
  const navigate = useNavigate()
  return (
    <div className="BlogCard" onClick={()=>navigate(`/blog/${info.id}/${info.slug}`)}>
      <div className="flex justify-between items-center mb-[16px] gap-[36px]">
        <div className="">
          <div className="flex items-center">
            <img className="BlogCard-profile ml-[10px]" src={info.author.avatar} alt="" />
            <div className="BlogCard-info">
              <h3>{info.author.full_name}</h3>
              <p>منتشر شده در {moment(info.created_at, 'YYYY/MM/DD').locale('fa').format('DD  MMMM  YYYY')} </p>
            </div>
          </div>
          <p className="BlogCard-title">{info.title}</p>
          {/* <p className="BlogCard-des">
          {parse(info.body)}
          </p> */}
        </div>
        <div className="BlogCard-img w-[195px] h-[195px]">
          <img src={info.thumbnail.path} />
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="flex gap-[17px] items-center">
          <div className="BlogCard-tag">سفر به کجا</div>
          <div className="flex items-center">
            <img src={clock} className='ml-[10px]'/>
            <p className="BlogCard-timetoread">12 دقیقه زمان مطالعه</p>
          </div>
        </div>
        <div className="flex gap-[12px] itemx-center">
          <div className="BlogCard-infobox bg-[#DEE5F7] text-[#2058E9] flex items-center">
            <img src={eye} className='ml-[7px]'/>
            <p  className="Danafont">32</p>
          </div>
          <div className="BlogCard-infobox BlogCard-infobox-red text-[#F10840] flex items-center">
            <img src={heart} className='ml-[7px]'/>
            <p className="Danafont">21</p>
          </div>
          <div className="BlogCard-infobox bg-[#DEF7F7] text-[#00A6A6] flex items-center">
            <img src={message} className='ml-[7px]'/>
            <p  className="Danafont">32</p>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
